export default "__VITE_ASSET__BLnQf2ua__"